(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:RefereeList
   *
   * @description
   *
   */
  angular
    .module('neo.services')
    .factory('items', items);

  function items($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/items/:idPerfil', {idPerfil: '@_idPerfil'}, {
      update: {
        method: 'PUT'
      },
      query: {
        method: 'GET',
        isArray: true
      }
    });
  }
}());